export default __webpack_public_path__ + "static/media/particlePlaylistPrimary.0e9c72a3.svg";